/* eslint-disable eqeqeq, no-unused-vars */

import React from 'react';
import Link from '../common/TrackedLink';

const CompareColumn = ({ product }) => {

	const productFeatures = product.bestUseCopies.map(
		(object, index) => {
			if(product.bestUseCopies[index].bolded)
				return <li key={ index }><b>{ object.copy }</b></li>
			return <li key={ index }>{ object.copy }</li>
		}
	);

	const priceBold = product.specificationCopies['List Price'].bolded;
	const exteriorBold = product.specificationCopies['Exterior Size'].bolded;
	const interiorBold = product.specificationCopies['Interior Size'].bolded;
	const exteriorMetricBold = product.specificationCopies['Exterior Size (metric)'].bolded;
	const interiorMetricBold = product.specificationCopies['Interior Size (metric)'].bolded;
	const capacityBold = product.specificationCopies['Capacity/Volume'].bolded;
	const lockTypeBold = product.specificationCopies['Lock Type'].bolded;
	const materialBold = product.specificationCopies['Material'].bolded;
	const perilTypeBold = product.specificationCopies['Peril Types'].bolded;
	const weightBold = product.specificationCopies['Weight'].bolded;

	let priceHtml;
	if(priceBold){
		priceHtml = (
			<li>
				<h3>Price Range</h3>
				<b>{ product.specificationCopies['List Price'].copy }</b>
			</li>
		);
	} else {
		priceHtml = (
			<li>
				<h3>Price Range</h3>
				<span>{ product.specificationCopies['List Price'].copy }</span>
			</li>
		);
	}

	let exteriorHtml;
	if(exteriorBold){
		exteriorHtml = (
			<li>
				<h3>Exterior Size</h3>
				<b>{ product.specificationCopies['Exterior Size'].copy }</b>
			</li>
		);
	} else {
		exteriorHtml = (
			<li>
				<h3>Exterior Size</h3>
				<span>{ product.specificationCopies['Exterior Size'].copy }</span>
			</li>
		);
	}

	let interiorHtml;
	if(interiorBold){
		interiorHtml = (
			<li>
				<h3>Interior Size</h3>
				<b>{ product.specificationCopies['Interior Size'].copy }</b>
			</li>
		);
	} else {
		interiorHtml = (
			<li>
				<h3>Interior Size</h3>
				<span>{ product.specificationCopies['Interior Size'].copy }</span>
			</li>
		);
	}


	let exteriorMetricHtml;
	if(exteriorMetricBold){
		exteriorMetricHtml = (
			<li>
				<h3>Exterior Size (metric)</h3>
				<b>{ product.specificationCopies['Exterior Size (metric)'].copy }</b>
			</li>
		);
	} else {
		exteriorMetricHtml = (
			<li>
				<h3>Exterior Size (metric)</h3>
				<span>{ product.specificationCopies['Exterior Size (metric)'].copy }</span>
			</li>
		);
	}

	let interiorMetricHtml;
	if(interiorMetricBold){
		interiorMetricHtml = (
			<li>
				<h3>Interior Size (metric)</h3>
				<b>{ product.specificationCopies['Interior Size (metric)'].copy }</b>
			</li>
		);
	} else {
		interiorMetricHtml = (
			<li>
				<h3>Interior Size (metric)</h3>
				<span>{ product.specificationCopies['Interior Size (metric)'].copy }</span>
			</li>
		);
	}

	let capacityHtml;
	if(capacityBold){
		capacityHtml = (
			<li>
				<h3>Capacity/Volume</h3>
				<b>{ product.specificationCopies['Capacity/Volume'].copy }</b>
			</li>
		);
	} else {
		capacityHtml = (
			<li>
				<h3>Capacity/Volume</h3>
				<span>{ product.specificationCopies['Capacity/Volume'].copy }</span>
			</li>
		);
	}

	let lockTypeHtml;
	if(lockTypeBold){
		lockTypeHtml = (
			<li>
				<h3>Lock Type</h3>
				<b>{ product.specificationCopies['Lock Type'].copy }</b>
			</li>
		);
	} else {
		lockTypeHtml = (
			<li>
				<h3>Lock Type</h3>
				<span>{ product.specificationCopies['Lock Type'].copy }</span>
			</li>
		);
	}

	let materialHtml;
	if(materialBold){
		materialHtml = (
			<li>
				<h3>Material</h3>
				<b>{ product.specificationCopies['Material'].copy }</b>
			</li>
		);
	} else {
		materialHtml = (
			<li>
				<h3>Material</h3>
				<span>{ product.specificationCopies['Material'].copy }</span>
			</li>
		);
	}

	let perilHtml;
	if(perilTypeBold){
		perilHtml = (
			<li>
				<h3>Peril Type</h3>
				<b>{ product.specificationCopies['Peril Types'].copy }</b>
			</li>
		);
	} else {
		perilHtml = (
			<li>
				<h3>Peril Type</h3>
				<span>{ product.specificationCopies['Peril Types'].copy }</span>
			</li>
		);
	}

	let weightHtml;
	if(weightBold){
		weightHtml = (
			<li>
				<h3>Weight</h3>
				<b>{ product.specificationCopies['Weight'].copy }</b>
			</li>
		);
	} else {
		weightHtml = (
			<li>
				<h3>Weight</h3>
				<span>{ product.specificationCopies['Weight'].copy }</span>
			</li>
		);
	}

	return (
		<ul className="col">
			<li>
				<figure>
					<img src={ product.productImage } alt={ product.modelNumber } />
					<figcaption>
						<h2>{ product.description }</h2>
						Model { product.modelNumber }
					</figcaption>
				</figure>
			</li>
			<li>
				<Link
					className="arrow-link"
					to={ `/product/${product.modelNumber}` }
				>
					View Details
				</Link>
			</li>
			{ priceHtml }
			{ exteriorHtml }
			{ exteriorMetricHtml }
			{ interiorHtml }
			{ interiorMetricHtml }
			{ capacityHtml }
			{ materialHtml }
			{ perilHtml }
			{ weightHtml }
			
			<li>
				<h3>Product features</h3>
				<ul>
					{ productFeatures }
				</ul>
			</li>
		</ul>
	);
};

export default CompareColumn;


// WEBPACK FOOTER //
// ./src/pages/productCompare/CompareColumn.js